import { DynamicDialogConfig } from 'primeng/dynamicdialog';

// Creamos una subclase con los valores por defecto que deseamos
export class GlobalDynamicDialogConfig extends DynamicDialogConfig {
    constructor() {
        super();
        this.draggable = false; // Deshabilita el movimiento globalmente
        this.resizable = false; // Opcional: deshabilita el cambio de tamaño
    }
}
